export default __webpack_public_path__ + "static/media/wobbly.aa376e4b.jpg";